#import './plan-fragment.graphql'
#import './cached-plan-fragment.graphql'

fragment PlanGroupFragment on PlanGroup {
    defaultCode
    activePlanCode
    plans {
        ...PlanFragment
    }
    isUserQuantityBased
    cachedPlan {
        ...CachedPlanFragment
    }
    isCycleBased
}
